import beautyTreasureLogo from "../../assets/images/beautytreasure/logo.png";
const Banner = ({ text, img }) => {
  return (
    <div className="bg-[#FFF8F0]">
      <div className="max-w-5xl mx-auto px-5 md:py-10 pt-5 pb-10 ">
        <div className=" w-[60px] md:w-[100px] aspect-video">
          <img
            src={beautyTreasureLogo}
            className="w-full h-full object-cover"
            alt="beauty treasure logo"
          />
        </div>
        <div className="flex flex-col md:flex-row gap-10  md:gap-20 items-center py-10">
          <p className=" flex-1  font-bold text-2xl md:text-3xl ">{text}</p>
          <div className="w-[min(400px,100%)] md:flex-1 ">
            <img
              src={img}
              className="w-full h-full object-contain"
              alt="product one"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
